module.exports = __webpack_public_path__ + "img/vr.6514fe66.png";